const dict = {
  'ja': {
    'Laplace ID': 'ラプラスID',
    'Sign In Account': 'ラプラスID情報',
    'Sign In': 'ログイン',
    'Log In': 'ログイン',
    'Back to Sign In': 'ログインへ戻る',
    'Back to Sign Up': '新規登録へ戻る',
    'Sign Up': 'ラプラスIDを新規作成する',
    'Sign Up Account': 'IDの新規作成',
    'Confirm Sign Up' : '確認コードの入力',
    'Code':'確認コード',
    'Confirm': '確認',
    'Regist verification code': '確認コードを登録',
    'Resend Code': '確認コード再送信',
    'I Forgot Password': 'パスワードを忘れた時',
    'Forgot Password': 'パスワードの再設定',
    'Username': 'ID (メールアドレス)',
    'Mail': 'ID (メールアドレス)',
    'Password': 'パスワード',
    'New Password': '新しいパスワード',
    'Retype Password':'パスワードの再入力',
    'Last name': '姓',
    'First name': '名',
    'Company/Institution name': '法人名',
    'Business': '法人',
    'Private': '個人',
    'Last name furigana' : '姓 (フリガナ)',
    'First name furigana': '名 (フリガナ)',
    'organization furigana': '法人名 (フリガナ)',
    'Enter your personal data': '個人情報の入力',
    'Personal data': '個人情報',
    'Enter': '登録',
    'Verify Contact':'連絡先の確認',
    'Account recovery requires verified contact information': 'ID (メールアドレス) を確認します',
    'Passwords do not match':'パスワードが一致しません',
    'Confirm your profile':'入力内容の確認',
    'Verify' : '確認',
    'Submit' : '登録',
    'Previous' : '前へ',
    'Next' : '次へ',
    'Back' : '修正',
    'Send Code':'確認コードを送信',
    'The Verification Code was resent.':'確認コードを再送信しました。',
    'The Verification Code was sent. Enter the 6 digit verification code described in the mail body and send it.':'に確認コードを送信しました。メール本文に記載されている6桁の確認コードを入力して送信してください。',
    'If you can not receive verification code, you can try to resend.':'確認コードが届かない場合は再送をお試しください。',
    'If you can not receive RESEND verification code, please check the question about Laplace ID.':'再送信を試しても確認コードが届かない場合はラプラスIDに関する質問をご確認ください。',
    'The question about Laplace ID':'ラプラスIDに関する質問',
    'Password strength is required belows':'パスワードの条件',
    'Require numbers':'数字を1つ以上含む',
    'Require uppercase letters':'英大文字を1文字以上含む',
    'Require lowercase letters':'英小文字を1文字以上含む',
    '8 letters more over':'8文字以上',
    'Enter verification code already sent.':'送信済みの確認コードをご入力ください',
    'Mail address style is not valid.':'メールアドレスの形式が正しくありません',
    'Please logout, and re-login':'一度ログアウトし、再度ログインし直してください',
    'Edit':'編集',
    'User does not exist.':'ID（メールアドレス）が登録されていません',
    'Username cannot be empty':'ID（メールアドレス）が入力されていません',
    'null failed with error Generate callenges lambda cannot be called..':'パスワードが入力されていません',
    'Incorrect username or password.':'パスワードが不正です',
    'Attribute value for custom:organization must not be null':'組織名を入力してください',
    'Entered Laplace ID is not registered':'入力されたID（メールアドレス）は登録されていません',
    'Invalid verification code provided, please try again.':'確認コードが不正です',
    'Code cannot be empty':'確認コードが入力されていません',
    'Attempt limit exceeded, please try after some time.':'試行回数を超過しました。しばらく待ってから再度お試しください',
    'Incorrect current password':'現在のパスワードが不正です',
    'Incorrect new password':'新しいパスワードが不正です',
    'Enter your ID':'IDを入力してください',
    'Enter your password':'パスワードを入力してください',
    'All displayed items are required.':'表示されている全ての項目が登録必須です。',
    'Required items':'入力必須の項目',
    'Your name':'お名前（姓・名・フリガナ）',
    'Name':'お名前',
    'Select Business or Private':'法人・個人のいずれかを選択',
    'If you select Business, enter your Company/Institution name':'法人の場合は法人名とフリガナ',
    'Agree to Terms of Service':'利用規約への同意',
    'Registration will be done with few more steps':'もう少しで登録完了です',
    'Press Enter to complete your registration':'登録ボタンをクリックすると登録完了です',
    'Remaining steps':'残りステップ数',
    'I read the Terms of service and agree to its contents.':'を読み、その内容に同意します',
    'Terms of service':'利用規約',
    'User is already confirmed.':'ユーザは既にコードによる確認が完了しています',
    'Enter your registered ID (mail address). You can receive an mail to reset your password.':'ご登録いただいているID（メールアドレス）を入力してください。パスワード再設定用のメールをお送りします。',
    'Logged out':'ログアウトしました',
    'LOGOUT':'ログアウト',
    'User profile':'ユーザ情報',
    'Plant management':'L・eye 発電所管理',
    'Company information':'企業情報',
    'Contact us':'お問い合わせ',
    'Privacy policy':'プライバシーポリシー',
    'Mail address style is not valid or not entered.':'メールアドレスの形式が正しくないか、入力されていません',
    'Verification code style is not valid or not entered.':'コードの形式が正しくないか、入力されていません',
    'You will receive verification code from new address.':'新しいメールアドレス宛に確認コードをお送りしました。',
    'Enter the 6 digit verification code described in the mail body and send it.':'メール本文に記載されている6桁の確認コードを入力して送信してください。',
    'Edit your id (mail address)':'ID (メールアドレス)の編集',
    'Enter your new mail address.':'新しいメールアドレスを入力してください。',
    'New mail address':'新しいメールアドレス',
    'Delete Laplace ID':'ID (メールアドレス) の廃止',
    'Delete ID':'廃止 (IDを削除)',
    'Do you delete your Laplace ID?':'現在のIDを削除しますか？',
    'Cancel':'キャンセル',
    'You will receive the verification code. Please enter the verification code described in the mail body.':'確認コードをお送りしました。メール本文に記載の確認コードを入力して登録してください。',
    'Your mail address is verified.':'メールアドレスの確認が完了しました。',
    'Please log in again and make the second confirmation.':'再度ログインし第2確認を行ってください。',
    'You can resubmit by clicking again':'もう一度クリックすることで再送信できます',
    'The new password and input contents are different':'新しいパスワードと入力内容が異なります',
    'Your password is updated.':'パスワードを更新しました',
    'Edit password':'パスワードの編集',
    'Current password':'現在のパスワード',
    'Retype new password':'新しいパスワードの再入力',
    'Change pass':'パスワードを変更',
    'Setting is updated':'設定を更新しました',
    'Edit personal data':'個人情報の編集',
    'Required':'必須',
    'Save':'保存',
    'The current password is not entered':'現在のパスワードが入力されていません',
    'Delete':'削除',
    'Forgot ID/Password':'ログインできないとき',
    'L eye LOGIN':'L・eye LOGIN',
    'Entered credentials are incorrect.':'認証情報に誤りがあります',
    'Cannot reset password for the user as there is no registered/verified email or phone_number':'未検証のメールアドレスのためパスワードリセットはできません',
    'https://www.lapsys.co.jp/english/':'https://www.lapsys.co.jp/',
    'https://www.lapsys.co.jp/english/policy/laplace_id.html':'https://www.lapsys.co.jp/policy/laplace_id.html',
    'https://www.lapsys.co.jp/english/policy/index.html':'https://www.lapsys.co.jp/policy/index.html',
    'mailto:lapsys_e@lapsys.co.jp':'https://contacts.laplaceweb.com/contacts/',
    'Invalid code provided, please request a code again.':'不正なコードです。確認コードを再送信の上、再入力してください',
    'My page':'マイページ',
    'Enter your ID and Password.':'IDとPasswordを入力して下さい。',
    'Check password':'パスワードの確認',
    'Your session is expired. Please re-login.':'セッションの有効期限が切れました。再度ログインして下さい。',
    'Error: "Local storage is missing an ID Token, Please authenticate"':'トークンが失われました。再度ログインして下さい。',
    'An account with the given email already exists.' : '入力されたメールアドレスは既に登録されています。',
    'Please try again from the beginning.' : 'もう一度はじめからお試しください。',
    'Password attempts exceeded' : '試行回数を超過しました。しばらく待ってから再度お試しください',
    'Reagree to Terms of Service' : '利用規約の再同意',
    'Terms of Service is updated. If you continue to use this service, please reconfirm Terms of Service.' : '利用規約が更新されました。サービスの利用を続行される場合は、以下のリンクよりご確認の上、再度ご同意ください。',
    'Continue' : '操作を続ける',

    'Mieruka Web' : 'Mieruka Web 管理',
    'Mieruka Web Setting' : 'PRコンテンツ一覧へ',
    'With Mieruka Web, you can create PR content that can be viewed on the Web by measurement data of the power plant.' : 'Mieruka Webでは発電所の計測データを活用し、Web上で閲覧可能なPRコンテンツを作成できます。',
    'MierukaWeb content list' : 'PRコンテンツ一覧',
    'You do not have registered PR contents.' : '登録されているPRコンテンツがありません。',
    'Free' : 'フリー',
    'Create PR Contents(measurement, graph and explanation screen):Please press "Next" button to see the power plants list, then click "Create" button of a site you want to use. Created PR Contents is displayed to MierukaWeb content list.' : '「L・eye 発電所管理画面」で登録した発電所に対して、計測画面やグラフ画面、説明画面が巡回するPRコンテンツを作成できます。作成したコンテンツはPRコンテンツ一覧に表示されます。',
    'Cruise config' : '巡回設定',
    'Screen taste' : '画面テイスト',
    'Cruise time (sec)' : '巡回秒数',
    'sec' : '秒',
    'Screen' : '画面',
    'Cruise Setting is done. you can confirm via below link.' : '設定の登録が完了しました。PRコンテンツ一覧から閲覧・編集できます。',
    'You can enter title strings up to 32 characters' : 'タイトルの文字数は32文字までです',
    'You can set cruise seconds from 10 sec to 3,600sec.' : '巡回秒数は 10～3600 秒で設定してください',
    'Delete above PR contents.' : '上のPRコンテンツを削除する。',
    'Do you delete below PR contents?' : '下記のPRコンテンツを削除しますか？',
    'Update' : '更新',
    'You can not update to currently used mail address.' : '現在と同じメールアドレスで更新することはできません。',
    'The title can be up to ' : '画面タイトルは',
    ' characters.' : '文字以内で入力してください',
    'Display title' : '画面タイトル',
    'Show' : '閲覧',
    'Copy URL' : 'URLをコピー',
    'Link url is copied' : 'URLをコピーしました',
    'PR screens are created : ' : 'PRコンテンツを作成しました : ',
    'Delete PR screens' : 'PRコンテンツの削除',
    'Service Tag' : '問い合わせ番号',
    'EDITABLE' : '変更可',
    'Screen ' : '画面',
    'Each screen' : '1画面あたり',
    'You can enter number only.' : '入力できるのは数字(0-9)のみです。',
    'Enter your plant name.' : '発電所名を入力してください。',
    'Enter cruise time (sec).' : '巡回秒数を入力してください',
    'screens' : '画面',
    'Cruise config is not found.' : '巡回設定が見つかりません',
    'Now loading...' : '読み込み中です...',
    'Editable cruise config is not found.' : '編集可能な巡回設定が見つかりません',
    'Created cruise config is not found.' : '登録されたPRコンテンツが見つかりません',
    'Authorization check is failed.' : '認可の確認に失敗しました',
    'Terms of Service is updated.' : '利用規約が更新されました。',
    'Please reconfirm it.' : '再度ご確認をお願いいたします。',
    'Failed to get cruise config.' : '巡回設定の取得に失敗しました',

    'Integrated monitoring' : 'L・eye 総合監視',

    'User view management': '利用者画面 管理',

    'Product list': '発電所一覧',
    'Supplier': '事業者',
    'Search by: ' : '検索対象：',
    'Search' : '検索',
    'Power Plant Name (Site Name)' : '発電所名 (サイト名)',
    'MAC Address' : 'MACアドレス',
    'Serial Number (S/N)' : 'シリアルNo (S/N)',
    'Pattern' : 'パターン',
    'Ppa Contents User' : '利用者',
    'Usage Status' : '利用状況',
    'Registered' : '利用中',
    'Unregistered' : '未利用',
    'Service data could not be obtained.' : 'サービスの情報を取得できませんでした',
    'Power plant data could not be obtained.' : '発電所の情報を取得できませんでした',
    'Failed to set pattern.' : 'パターン設定に失敗しました',
    'Failed to confirm company you belong.' : '所属事業者の確認に失敗しました',
    '[Sample] This is display image as user' : '[サンプル]利用者画面の表示イメージです',

    'User screen setting': '利用者画面 設定',
    'Patterns name': 'パターン名',
    'Pattern of Default Settings': 'デフォルト設定のパターン',
    'Do you want to change this pattern to the default pattern?': 'このパターンをデフォルトパターンに変更しますか？',
    'It will be applied from the power plants that will be added in the next': '今後追加される発電所から適用されます',
    'There is power plants that have already set up this pattern.': 'このパターンを設定済みの発電所があります。',
    'Do you want to save your edits?': '編集内容を保存してもよろしいですか？',
    'Change': '変更',
    'Create': '新規作成',
    'Copy': 'コピー',
    'Copy: ': 'コピー：',
    'You can only create a maximum of 10 patterns.': 'パターンは最大10件までしか作成できません',
    'Setting': '設定',
    'Pattern name can set into 20 characters': 'パターン名は20文字で設定してください',
    'Please enter a pattern name': 'パターン名を入力してください',
    'Use this pattern as default': 'このパターンをデフォルト設定にする',
    'Display item setting': '表示項目設定',
    'You can select the screens and items to be displayed on the user\'s screen.': '利用者画面に表示する画面・項目を選択できます。',
    'Click here for a screen sample': '画面サンプルはこちら',
    'Invoice amount (estimated amount/graph) : Displays estimated amount and graph of invoice amount': '請求金額 (金額目安/グラフ) : 請求金額目安、請求金額グラフを表示します',
    'Conversion of Energy generated: The measurement values are converted to the items around you and displayed.': '発電量の換算 : 計測値を身の回りの項目に換算して表示します',
    'Measurement value (measurement value/graph): display the measurement value and graph.': '計測値 (計測値/グラフ) : 計測値およびグラフを表示します',
    'Displays storage battery items in addition to the items selected above': '上記で選択した項目に加えて蓄電池項目を表示',
    'Additional display items': '追加表示項目',
    'Charged Power(daily data)': '蓄電池充電電力量(本日値)',
    'Discharged Energy(daily data)': '蓄電池放電電力量(本日値)',
    'SOC': '蓄電池残量',
    'Measurement value': '計測値',
    'View all items': 'すべての項目を表示',
    'No sold energy': '売電電力量なし',
    'No sold energy and energy consumption': '売電電力量・消費電力量なし',
    'No energy consumption and self energy consumption': '消費電力量・自家消費電力量なし',
    'No sold energy and purchased energy and energy consumption and self energy consumption': '売電電力量・買電電力量・消費電力量・自家消費電力量なし',
    'Energy generated (daily data)': '発電電力量 (本日値)',
    'Display items': '表示項目',
    'Energy generated': '発電電力量',
    'Sold energy': '売電電力量',
    'Purchased energy': '買電電力量',
    'Energy consumption': '消費電力量',
    'Self energy consumption' : '自家消費電力量',
    'daily data': 'すべて本日値',
    'Graph': 'グラフ',
    'Graph the selected item in the measurement value.': '計測値で選択した項目をグラフ化します',
    'Calculation setting': '計算式設定',
    'You can set a formula for calculating the estimated amount to be billed. Calculation results are rounded down to the nearest yen.'
      : '請求金額目安を算出するための計算式を設定できます。計算結果は円未満を切捨てて表示します。',
    'Basic fee / Minimum fee' : '基本料金 / 最低料金',
    'Renewable Energy Levy' : '再エネ賦課金',
    'Fuel cost adjustment' : '燃料費調整',
    'Unit price setting' : '単価を設定する対象',
    'Number of conditions (lines)' : '条件(行)数',
    'Condition' : '条件',
    'Break point of the amount of power' : '電力量の区分',
    'Unit price of the amount of power' : '電力量の単価',
    'or more': '以上',
    'exceed': 'を超えると',
    'yen': '円',
    'Registration failed.': '登録に失敗しました',
    'Fail to new registration': '新規登録に失敗しました',
    'The deletion process failed.': '削除に失敗しました',
    'Failed to update.': '更新に失敗しました',
    'Please enter in the correct format (numbers, periods, or two decimal places)' : '正しい形式（半角数字、ピリオド、小数第2位まで）で入力してください',
    'Please enter in the correct format (numbers, periods, minus, or two decimal places)' : '正しい形式（半角数字、ピリオド、マイナス、小数第2位まで）で入力してください',
    'Please select at least one screen.': '少なくとも1画面を選択してください',
    'Obtaining a business ID': '事業者IDの取得中',
    'Failure to obtain a business ID': '事業者IDの取得に失敗しました',
    'Obtaining PPA setting data': 'PPA設定情報の取得中',
    'Failure to obtain PPA setting data': 'PPA設定情報の取得に失敗',
    'Set Break point of the amount of power': '電力量の区分を設定してください',
    'Set the unit price of the amount of power': '電力量の単価を設定してください',
    'Break point of the amount of power: Please enter the correct format (numbers or a positive integer)': '電力量の区分：正しい形式(半角数字、正の整数)で入力してください',
    'Unit price of the amount of power: Please enter in the correct format (numbers, periods or two decimal places)': '電力量の単価：正しい形式(半角数字、ピリオド、小数第2位まで)で入力してください',
    'The name is the same as the registered pattern. Please change the pattern name.' : '登録済みのパターンと同じ名前です。パターン名を変更してください',

    'Invoices' : '請求一覧',
    'Invoice date' : '掲載日',
    'Subject' : '件名',
    'Amount (tax included)' : '金額 (税込)',
    'Invoice' : '請求書',
    'Fail to get invoice list.' : '請求一覧情報を取得できませんでした',
    'Fail to get invoice report.' : '請求書を取得できませんでした',
    'Failed to confirm access to invoice service. Please reload the screen.' : '請求サービスのアクセス確認に失敗しました。ブラウザをリロードし再度お試しください',
    'From January 2024 onward, we have uploaded invoices to "Rakuraku Meisai".': '2024年1月分以降は「楽楽明細」にて請求書をアップロードしております。',
    'If you have not received any notification from "Rakuraku Meisai", please contact us at the following.' : '「楽楽明細」からのお知らせ等が確認いただけていない場合は、以下までお問合せください。',
    'Laplace System Co., Ltd., Administration Department, Finance & Accounting Division, Subscription Section' : '株式会社ラプラス・システム　管理部　財務・経理課　月額プラン担当',
    'TEL: 075-604-4731 (weekdays 9:00～17:30) E-mail: accounting@lapsys.co.jp' : '電話番号: 075-604-4731 (平日9:00～17:30) メールアドレス: accounting@lapsys.co.jp',

    'Standard solar power generation (All electricity sales)' : '太陽光発電 標準(全量売電)',
    'Self consumption solar power generation' : '太陽光発電自家消費',
    'Standard solar power generation (Surplus electricity sales)' : '太陽光発電 標準(余剰売電)',
    'Standard solar power generation (Self consumption)' : '太陽光発電 標準(自家消費)',
    'Self consumption solar power generation + Battery' : '太陽光発電自家消費+蓄電池',
    'Customized screen' : 'カスタマイズ画面',

    'Service list' : 'サービス一覧',
    'The Laplace ID allows you to take advantage of a variety of services.' : 'ラプラスIDではさまざまなサービスをご活用いただけます。',
    'Open' : '開く',
    'This is the screen to link and manage power plants that have Laplace ID and L eye monitoring screen.' : 'ラプラスIDとL・eye監視画面を導入している発電所を連携・管理するための画面です。',
    'It is possible to manage the status and information of multiple power plants in one place.' : '複数の発電所の状況・情報をひとつにまとめて管理できます。',
    'It is possible to create PR content that can be viewed on the web using measurement data from power plants.' : '発電所の計測データを活用し、Web上で閲覧可能なPRコンテンツを作成できます。',
    'It is possible to check the list of power plants and set the user screen.' : '発電所一覧の確認および、利用者画面の設定を行うことができます。',
    'User Screen Management' : '利用者画面 管理',
    // 発電所管理システム
    'Power Plant Management' : '発電所管理システム',
  }
};
export default dict;
